import dayjs from "dayjs";

import { Document } from "@/api/generated";
import { DocumentTypeOptions } from "@/constants/management";

export const documentGroups = [
  { title: "購入のとき", types: [0, 1, 2, 3] },
  { title: "ローン", types: [4, 5] },
  { title: "賃貸", types: [6, 7] },
  { title: "税金・保険", types: [9, 10, 8] },
  { title: "その他", types: [11] },
];

export const documentLabel = (type: number) =>
  type === 11
    ? "その他（領収書など）"
    : DocumentTypeOptions.find((option) => option.value === type)?.label || "物件書類";

export const fileTypeLabel = (name: string) => {
  const extension = name.includes(".") ? name.split(".").pop()?.toLowerCase() : "";
  if (extension === "pdf") return "PDF";
  if (["jpg", "jpeg", "png", "gif", "webp", "heic", "heif", "bmp", "tif", "tiff", "svg"].includes(extension))
    return "画像";
  return extension ? extension.toUpperCase() : "ファイル";
};

export const documentMeta = (document: Document, added = false) => {
  const date = dayjs(document.created_at);
  return [
    document.created_at && date.isValid() ? date.format(`YYYY年M月D日${added ? "に追加" : ""}`) : "追加日不明",
    fileTypeLabel(document.name),
  ].join(" ・ ");
};

export const MEMO_MAX_LENGTH = 30;
export const memoLength = (memo: string) => Array.from(memo).length;

// 実controllerは文字列を返し、schemaはsigned_urlを定義するため、この画面だけ両方を解釈する。
export const nativeDownloadUrl = (data: unknown): string | null => {
  if (typeof data === "string") return data || null;
  if (data && typeof data === "object" && "signed_url" in data) {
    const url = (data as { signed_url?: unknown }).signed_url;
    return typeof url === "string" && url ? url : null;
  }
  return null;
};
